import React, { Dispatch, SetStateAction, useEffect, useState, useCallback } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import './inviteSlidePanel.scss'
import { InviteView } from './inviteView';
import { useQueryDictionary } from "src/hooks/useQueryDictionary";
import { BulkUsersImportTable } from "../bulk-invite-slide/bulkUsersImportTable";
import { useRolesPermissions } from "@src/hooks";
import { UserRoleEnum } from "@src/types";
import { BulkUsersImportDistrictAdminTable } from "../bulk-invite-slide/bulkUsersImportDistrictAdminTable";

type Props = {
  setBulkInviteSlide: Dispatch<SetStateAction<boolean>>;
  bulkInviteSlide: boolean;
  reLoadData?: (v?: any) => void;
};

export function InviteSlidingPanel(props: Props) {
  const {setBulkInviteSlide, bulkInviteSlide, reLoadData} = props;
  const [slide, setSlide] = useState<number>(0);
  const [jsonParse, setJsonParse] = useState<any[]>([]);
  const accountOptions = useQueryDictionary({dictionary: 'Customers'});
  const schoolOptions = useQueryDictionary({dictionary: 'Schools'});

  const isDistAdmin = useRolesPermissions([UserRoleEnum.DistrictAdmin]);

  useEffect(() => {
    if (jsonParse.length > 0) setSlide(1);
  }, [jsonParse])

  const closeSlide = useCallback(() => {
    setJsonParse([]);
    setSlide(0);
    setBulkInviteSlide(false);
    reLoadData?.();
  }, [reLoadData, setBulkInviteSlide]);

  return (
    <div>
      <SlidingPane
        width="90%"
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={bulkInviteSlide}
        title={slide === 0 ? "Invite Users to Open Parachute" : "Bulk User Upload"}
        onRequestClose={closeSlide}
      >
        {slide === 0 ?
        <InviteView setJsonParse={setJsonParse} accountOptions={accountOptions}
                              schools={schoolOptions} closeSlide={closeSlide}/> :
        isDistAdmin ? <BulkUsersImportDistrictAdminTable jsonParse={jsonParse} accountOptions={accountOptions}
          schoolOptions={schoolOptions} closeSlide={closeSlide}/> :
        <BulkUsersImportTable jsonParse={jsonParse} accountOptions={accountOptions}
          schoolOptions={schoolOptions} closeSlide={closeSlide} isDistAdmin={isDistAdmin}/>
        }
      </SlidingPane>
    </div>
  );
}
